// ==============================|| PRESET THEME - THEME1 ||============================== //

const Theme = () => {
  const contrastText = "#ffffff";

  // Brand palette: #02462E (deep green) + #FEC700 (golden yellow)
  let primaryColors = [
    "#e6f2ed",   // lighter
    "#b3d4c4",   // 100
    "#80b69b",   // 200
    "#4d9872",   // light
    "#267a52",   // 400
    "#02462E",   // main  ← brand green
    "#023d28",   // dark
    "#023422",   // 700
    "#012b1c",   // darker
    "#012216",   // 900
  ];
  let secondaryColors = [
    "#F7F8FA",   // lighter  (page background)
    "#FEC700",   // 100      ← brand yellow
    "#FEC700",   // 200
    "#e8e8e8",   // light
    "#c0c0c0",   // 400
    "#8a8a8a",   // 500
    "#ffffff",   // main
    "#3E4853",   // dark
    "#1a1a1a",   // 800
    "#0d0d0d",   // darker
  ];
  let errorColors = ["#FFE7D3", "#FF805D", "#FF4528", "#DB271D", "#930C1A"];
  let warningColors = ["#FFF8D6", "#FFE066", "#FEC700", "#c9a000", "#8a6d00"];
  let infoColors = ["#E6F2ED", "#80b69b", "#4d9872", "#267a52", "#02462E"];
  let successColors = ["#E6F2ED", "#80b69b", "#4d9872", "#267a52", "#02462E"];

  let sicpaColors = ["#02462E", "#ffffff", "#F7F8FA"];

  return {
    primary: {
      lighter: primaryColors[0],
      100: primaryColors[1],
      200: primaryColors[2],
      light: primaryColors[3],
      400: primaryColors[4],
      main: primaryColors[5],
      dark: primaryColors[6],
      700: primaryColors[7],
      darker: primaryColors[8],
      900: primaryColors[9],
      contrastText,
    },
    secondary: {
      lighter: secondaryColors[0],
      100: secondaryColors[1],
      200: secondaryColors[2],
      light: secondaryColors[3],
      400: secondaryColors[4],
      500: secondaryColors[5],
      main: secondaryColors[6],
      dark: secondaryColors[7],
      800: secondaryColors[8],
      darker: secondaryColors[9],
      contrastText,
    },
    error: {
      lighter: errorColors[0],
      light: errorColors[1],
      main: errorColors[2],
      dark: errorColors[3],
      darker: errorColors[4],
      contrastText,
    },
    warning: {
      lighter: warningColors[0],
      light: warningColors[1],
      main: warningColors[2],
      dark: warningColors[3],
      darker: warningColors[4],
      contrastText: "#02462E",
    },
    info: {
      lighter: infoColors[0],
      light: infoColors[1],
      main: infoColors[2],
      dark: infoColors[3],
      darker: infoColors[4],
      contrastText,
    },
    success: {
      lighter: successColors[0],
      light: successColors[1],
      main: successColors[2],
      dark: successColors[3],
      darker: successColors[4],
      contrastText,
    },
    sicpa: {
      main: sicpaColors[0],
      lighter: sicpaColors[1],
      light: sicpaColors[2],
    },
  };
};

export default Theme;
